// Keep md and below in sync with $breakpoints.md in _variables.scss.
if (window.matchMedia('(max-width: 768px)').matches) {
	document.querySelectorAll<HTMLDetailsElement>('.faq__item[data-open-desktop]').forEach((item) => { item.open = false; });
}
